import List from '../views/Fechamento/Crud'

let routes = {
    path: '/fechamentos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/fechamentos',
            name: 'list-fechamento',
            component: List,
            meta: {
                pageTitle: 'Histórico de Fechamentos de Dia',
                breadcrumb: [
                    {
                        text: 'Fechamentos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
